import { PaginationResult } from "../../../../../Shared/Model/PaginationResult";
import { PromoBars } from "../../Model/PromoBar/PromoBars";

import { OffersPromoRepository } from "../../Repository/OffersPromoRepository";

export interface GetPromoBarsUseCase {
  invoke: (page: number, pageSize: number, search: string) => Promise<PaginationResult<PromoBars>>;
}

export class GetPromoBars implements GetPromoBarsUseCase {
  private Repo: OffersPromoRepository;
  constructor(_Repo: OffersPromoRepository) {
    this.Repo = _Repo;
  }

   invoke(page: number, pageSize: number, search: string){
    const getData = this.Repo.getPromoBars(page, pageSize, search);
    return getData;
  }
}